import { AuthActionType } from 'store/actionTypes/auth-action-type';
import { IAction } from 'store/state/app-state';
import { IAuthState } from 'store/state/auth-state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AuthReducer = (state: IAuthState = null, action: IAction<any>): IAuthState => {
    switch (action.type) {
        case AuthActionType.PATIENT_LOGIN_REQUEST:
            const authConfigs = {
                cognitoUserId: '',
                refreshToken: action.payload.refreshToken,
                accessToken: action.payload.jwtToken,
                expiration: action.payload.expiration,
                deviceId: action.payload.deviceId,
            };
            return {
                ...state,
                authConfigs,
                abilities: action.payload.abilities,
                username: action.payload.userName,
                userIdEnc: action.payload.userIdEnc,
                patientNumber: action.payload.patientNumber,
                patientIdEnc: action.payload.patientIdEnc,
                profilePhoto: action.payload.profilePhoto,
                rolePermissions: action.payload.rolePermissions,
                forceRedirection: action.payload.forceRedirection,
                timezoneId: action.payload.timezoneId,
                moduleNotifications: action.payload?.moduleNotifications,
                isSubscribed: action.payload?.isSubscribed,
                needPasswordReset: action.payload?.needPasswordReset,
            };
        case AuthActionType.PATIENT_PATIENT_LOGOUT_REQUEST:
            return null;
        case AuthActionType.PATIENT_CHANGE_LANGUAGE:
            return {
                ...state,
                language: action.payload,
            };
        case AuthActionType.PATIENT_STORE_MENU_DETAILS:
            return {
                ...state,
                menuDetails: action.payload,
            };
        case AuthActionType.PATIENT_PROFILE_PIC_UPDATE:
            return {
                ...state,
                profilePhoto: action.payload,
            };
        case AuthActionType.PATIENT_PROFILE_USERNAME_UPDATE:
            return {
                ...state,
                username: action.payload,
            };
        case AuthActionType.PATIENT_UPGRADE_TO_CARE_PLAN:
            return {
                ...state,
                isSubscribed: true,
            };
        case AuthActionType.PATIENT_PASSWORD_RESET:
            return {
                ...state,
                needPasswordReset: false,
            };
        case AuthActionType.PATIENT_UPDATE_ACCESS_TOKEN:
            return {
                ...state,
                authConfigs: { ...state.authConfigs, accessToken: action.payload.accessToken },
            };
        default:
            return state;
    }
};
